import { Backdrop, Box, Button, CircularProgress, Modal, Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useState, useEffect } from "react";
import { Switch } from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { onboardingServices } from "../../services/onboardingServices";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { adminServices } from "../../services/adminServices";
import _ from "lodash";
import { isEmptyDash } from "../../constant";
import AlertComponent from "../alert/alert";
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

// function createData(name, calories, fat, carbs, protein) {
//   return { name, calories, fat, carbs, protein };
// }

const rows2 = [createData(), createData()];
const rows = [
  createData("Do you have any of your relative working in Avaada?", 159, 6.0),
  createData(
    "If any of your owners, directors/officers, senior management, or employees ever been the subject of an Anti- Bribery and Anti-Corruption allegation or investigation or been convicted of a crime?",
    237,
    9.0
  ),
  createData(
    "If the beneficial owner of your organization held wholly or partly by a government official/ entity or a public official?",
    262,
    16.0
  ),
  createData(
    "Are owners, directors/officers, senior management, affiliated with government officials/ entities?",
    305,
    305
  ),
  createData(
    "Will the work/services to be performed require interaction with government officials/entities?",
    356,
    305
  ),
  createData(
    "Will you engage a sub-vendor to conduct work on Avaada’s behalf?",
    356,
    305
  ),
  createData(
    "Are you involved in any joint ventures and/or lobbying with government or quasi- government officials/entities?",
    159,
    6.0
  ),
  createData(
    "Do you have a written Anti- Bribery and Anti-Corruption policy in place covering compliance with anti-bribery and corruption laws?",
    159,
    6.0
  ),
  createData(
    "Do you have any relevant public local criminal record?",
    159,
    6.0
  ),
  createData(
    "Are you involved in criminal/civil litigation, bankruptcy, or any Other Dispute?",
    159,
    6.0
  ),
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const documentArr = ["Documents", "Package_Documents", "RFQ_Documents" ];

const fieldArr = ["SAP Finance Fields", "SAP Taxation Fields", "Buyer", "SAP Details", "Fields" ];

const fieldAndDocumentArr = ["Business and Contact Information", "Technical, Compliance, and Quality Assurance Documentation", "Financial, Tax and Operational Information", "Banking Information", "Route_Details", "Transporter_Details", "Vendor Registration Form" ];

const existUniqueNameArr = ["projectName", "packageName", "categoryId", "subcategoryId", "departmentId", "purchaseType", "packageType" ];

function ControlPanel1(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [tableDetails, setTableDetails] = useState({ sections: [] });
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };
  const [opencontrolPanel, setopencontrolPanel] = React.useState(false);
  const [openUpdateFieldModal, setopenUpdateFieldModal] = React.useState(false);
  const [stepId, setStepId] = React.useState(null);

  const handleClose = () => {
    setopencontrolPanel(false);
    setConfirmObj(null);
    settexted("");
  };
  const handleCloseUpdateFieldModal = () => {
    setopenUpdateFieldModal(false);
    setConfirmObj(null);
    setDuplicateConfirmObj(null);
    settexted("");
  };
  // console.log("ControlPanel1",props);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmObj, setConfirmObj] = useState(null);
  const [duplicateConfirmObj, setDuplicateConfirmObj] = useState(null);
  const [updateInputText, setUpdateInputText] = useState("");
  const [descriptionToggleStates, setdescriptionToggleStates] = useState(
    rows.map(() => false)
  );
  const [displayName, setDisplayName] = useState("");
  const [type, setType] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [dataObj, setDataObj] = useState(null);
  const [texted, settexted] = useState(" ");
  const [fieldTypeArr, setFieldTypeArr] = useState([]);
  const handleSectionIdChange = (newSectionId) => {
    setSectionId(newSectionId);
  };
  const handleOpen = (data) => {
    setopencontrolPanel(true);
    // console.log("Opened control panel for step:", data, props);
    setStepId(data?._id);
    setSectionId(data?._id);
    setDataObj(data);

    if (_.includes(fieldArr, data?.title)) {
      setFieldTypeArr([
        {"lable": "String", "value": "String"},
        {"lable": "Dropdown", "value": "Dropdown"},
        {"lable": "Date", "value": "Date"},
      ])
    }
    
    if (_.includes(documentArr, data?.title)) {
      setFieldTypeArr([
        {"lable": "File", "value": "File"},
      ])
    }
    
    if (_.includes(fieldAndDocumentArr, data?.title)) {
      let arr = [
        {"lable": "String", "value": "String"},
        {"lable": "Dropdown", "value": "Dropdown"},
        {"lable": "Date", "value": "Date"},
        {"lable": "File", "value": "File"},
      ];
      if (props?.selectedModuleOption?.value == "VendorOnboarding") {
        arr.push({"lable": "MultiField", "value": "MultiField"});
      }
      setFieldTypeArr(arr);
    }
    
  };
  const handleDisplayNameChange = (event) => {
    setDisplayName(event.target.value);
  };

  const handleTypeChange = (event) => {
    setType(event.target.value);
    setInputValue('');
    let selectedValue = event.target.value;
    if (selectedValue === 'File') {
      settexted('i.e ".pdf",".doc",".xlsx" ');
    } else if (selectedValue === 'Dropdown') {
      settexted("i.e a,b,c");
    } else if (selectedValue === 'MultiField') {
      settexted("i.e a,b,c");
    } else {
      settexted("");
    }

  };

  const handleInputValueChange = (event) => {
    setInputValue(event.target.value);
  };

  useEffect(() => {

    // setTableDetails();

  }, [tableDetails]);

  const handleSubmit = (event) => {
    // event.preventDefault();
    // console.log("Form submitted:", displayName, type, inputValue);
    setIsLoading(true);
    const bodyData = {
      name: displayName,
      type: type,
      sectionId: sectionId,
    };
    if (_.includes(existUniqueNameArr, displayName)) {
      openAlert(true, "error", `This field is already exist in application.`);      
    }
    if (inputValue && inputValue !== '') {
      if (type === 'File') {
        if (inputValue.startsWith('"') && inputValue.endsWith('"')) {
          var fileTypesArray = inputValue.replace(/"/g, "").split(',');
          bodyData.validation = [{
            "isFileExtension": true,
            "fileTypes": fileTypesArray
          }];
        } else {
          openAlert(true, "error", 'Input value is not properly formatted. Please enter file types enclosed in double quotes, separated by commas, like ".pdf",".xlsx",".doc",".ppt"');
        }
      } else if (type === 'Dropdown') {
        const valuesArray = inputValue.replace(/"/g, '').split(',');
        bodyData.options = valuesArray;
      } else if (type === 'MultiField') {
        const valuesArray = inputValue.replace(/"/g, '').split(',');
        bodyData.child = [{
          options: valuesArray,
          name: displayName,
          type: "Dropdown",
        }, {
          name: displayName,
          type: "String",
        }];
      }
    }
    
    let promise = "";
    if (props?.selectedModuleOption?.value == "VendorOnboarding") {    
      promise = onboardingServices.createStepField(bodyData, props?.stepId);    
    } 
    else {   
      // console.log(bodyData, dataObj, props?.selectedModuleOption); 
      
      bodyData.moduleName = props?.selectedModuleOption?.value;
      bodyData.page = props?.selectedPageOption?.value;
      bodyData.section = dataObj?.title;   
      bodyData.uniqueName = _.camelCase(displayName);     
      promise = adminServices.createFieldConfig(bodyData);  
    } 
    
      promise.then(function (response) {
        if (response.data.success === true) {
          setTableDetails(response.data.data);
          
          if (props?.selectedModuleOption?.value == "VendorOnboarding") {    
            props.getStepById(props?.stepId, `? onboardingType = ${props?.selectedPageOption?.value}`);  
          } 
          else {   
            props.getFieldConfig(props?.selectedModuleOption?.value, props?.selectedPageOption?.value);             
          } 
          setopencontrolPanel(false);
          
          setDisplayName("");
          setType("");
          setInputValue("");
        } else {
          setTableDetails({});
        }
      })
      .catch(function (error) {
        console.error(error);
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally(() => {
        setIsLoading(false);
        // setDisplayName("");
        // setType("");
        // setInputValue("");

      });
  };
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const [inputStates, setInputStates] = useState(rows.map(() => ""));

  const handleInputChange = (index, value) => {
    const newInputStates = [...inputStates];
    newInputStates[index] = value;
    setInputStates(newInputStates);
  };

  const handleNewToggle = (paramType) => {
    let obj = {
      fieldId: confirmObj?.row?._id,
      required: confirmObj?.row?.required,
      display: confirmObj?.row?.display,
      // type: confirmObj?.row?.type,
      // name: confirmObj?.row?.name,
    };
    
    if (paramType == "Modal") {
      obj["type"] = confirmObj?.row?.type;
      obj["name"] = confirmObj?.row?.name;      
    }
    obj[confirmObj?.blockName] = !confirmObj?.row[confirmObj?.blockName];

    if (isEmptyDash(obj.name) && paramType == "Modal") {
      openAlert(true, "error", `Please enter a valid name.`);
      return;
    }

    if (obj.type == "Dropdown" || obj.type == "MultiField") {
      obj["options"] = confirmObj?.row?.options;
      // console.log(duplicateConfirmObj, confirmObj, obj, arr);
    }

    // let bodyData = {
    //   fieldUpdates: [obj],
    // };
    props.updateStepField(obj, confirmObj?.row?._id);
    setIsConfirmModalOpen(false);
    handleCloseUpdateFieldModal();
  };
  const handledescriptionToggleStates = (index) => {
    const newStates = [...descriptionToggleStates];
    newStates[index] = !newStates[index];
    setdescriptionToggleStates(newStates);
  };

  const openConfirmModal = (row, index, blockName) => {
    setIsConfirmModalOpen(true);
    setConfirmObj({ row, index, blockName });
    setDuplicateConfirmObj({ row, index, blockName }); 
  };

  const editField = (row, index, blockName) => {
    setopenUpdateFieldModal(true);
    setConfirmObj({ row, index, blockName });
    setDuplicateConfirmObj({ row, index, blockName });    
  };

  const deleteEle = (row, index, blockName) => { 
    let optionsArr = _.cloneDeep(confirmObj?.row?.options);
    // let arr = optionsArr.filter(ele => ele.optionName != row.optionName ) ;
    optionsArr[index].isDeleted = !optionsArr[index].isDeleted;
    console.log(optionsArr);
    
    setConfirmObj((prevData) => ({ ...prevData, row: {...prevData?.row, options: optionsArr }, })); 
  };

  const onUpdateInputChange = (e) => {
    let {name, value} = e.target;   
    setUpdateInputText(value);
  };

  const onUpdateNameInputChange = (e) => {
    let {name, value} = e.target;   
    setConfirmObj((prevData) => ({ ...prevData, row: {...prevData?.row, name: value} }));  
  };
  
  const onAddInput = () => {
    let arr = updateInputText?.split(',')?.map(ele => ({"optionName" : _.trim(ele), "isDeleted": false}));
    setConfirmObj((prevData) => ({ ...prevData, row: {...prevData?.row, options: [...arr, ...prevData?.row?.options]}, }));  
    setUpdateInputText("");
    // console.log(arr, confirmObj); 
  };

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
    setConfirmObj(null);
  };
  const handleNewInputChange = (value) => {
    setNewInputValue(value);
  };
  const [newInputValue, setNewInputValue] = useState("");

  return (
    <>
      <div class="text-centers pt-3 pb-2">
        <TableContainer className="mb-3" component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell className="table_react_listing_controlpanel_block">
                  {props?.tableDetails?.title}
                  {/* Business and Contact Information */}
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  className="table_react_listing_controlpanel_block"
                >
                  Display
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  className="table_react_listing_controlpanel_block"
                >
                  Mandatory
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  className="table_react_listing_controlpanel_block"
                >
                  Type
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  className="table_react_listing_controlpanel_block"
                >
                  Action
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody className="cp-tbody">
              {props?.tableDetails?.fields.map((row, index) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell
                    className="cell_tabel_controlpanel_listing_blockss"
                    component="th"
                    scope="row"
                  >
                    {row.name}
                  </StyledTableCell>

                  <StyledTableCell
                    align="left"
                    className="cell_tabel_controlpanel_listing_blockss"
                  >
                 <div className="section_controlpanel_colume">
                 <label>No</label>
                    <Switch
                      checked={row.display}
                      onChange={() => openConfirmModal(row, index, "display")}
                    />
                    <label>Yes</label>
                 </div>
                  </StyledTableCell>
                  <StyledTableCell
                    align="left "
                    className="cell_tabel_controlpanel_listing_blockss"
                  >
                     <div className="section_controlpanel_colume">
                     <label>No</label>
                    <Switch
                      checked={row.required}
                      onChange={() => openConfirmModal(row, index, "required")}
                    />
                    <label>Yes</label>
                     </div>
                  </StyledTableCell>
                  
                  <StyledTableCell
                    align="left "
                    className="cell_tabel_controlpanel_listing_blockss"
                  >
                    <label>{row?.type}</label>
                  </StyledTableCell>
                  <StyledTableCell
                    align="left "
                    className="cell_tabel_controlpanel_listing_blockss"
                  >
                    
                    <Button
                      className="" variant="contained"
                      onClick={() => editField(row, index)}
                    >
                      Edit
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Button
          className="" variant="contained"
          onClick={() => handleOpen(props?.tableDetails)}
        >
          + Add Row
        </Button>
        
        <Modal
          open={isConfirmModalOpen} // Fix: use showResetSuccessModal instead of open
          onClose={closeConfirmModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="lets_block_modal_listing"
            sx={{
              position: "absolute",
              width: 400,
              bgcolor: "background.paper",
              border: "2px solid #000",
              p: 2,
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="text-center">
              <div class="modal-header">
                <h5 class="modal-title" id="contactModalLabel"></h5>
                <button
                  type="button"
                  class="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="7f6r2r"
                  onClick={closeConfirmModal}
                ></button>
              </div>
              {/* <h6 className="react_modal_changed_password">
                    Password Changed
                  </h6> */}
              <Typography className="vendor_succrssfully_block_main">
                Do you really want to change it?
              </Typography>
              <Button
                className="btn-info cp-cancel-btn "
                onClick={closeConfirmModal}
                sx={{ mt: 2 }}
              >
                Cancel
              </Button>
              <Button
                className="btn btn-success lets_btn_confirm "
                onClick={() => handleNewToggle("Toggle")}
                sx={{ mt: 2 }}
              >
                Confirm
              </Button>
            </div>
          </Box>
        </Modal>
        {/* Add Row Modal Table  */}
        <Modal
          open={opencontrolPanel}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="lets_block_modal_listing_controlpanel_table"
            sx={style}
          >
            <div className="modal-header">
              <h5 class="modal-title" id="contactModalLabel">
                {dataObj?.title}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                fdprocessedid="7f6r2r"
                onClick={handleClose}
              ></button>
            </div>
            <div class="modal-body">
              <div
                className="vendor_configuration_list_block"
              >
                <table className="table" id="employeeTable">
                  <thead>
                    <tr>
                      <th className="vendor_tabels_panel">Display Name</th>
                      <th className="vendor_tabels_panel">Type</th>
                      <th className="vendor_tabels_panel">Input Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          className="form-control form_h_modalesa"
                          value={displayName}
                          onChange={handleDisplayNameChange}
                          placeholder="Display Name"
                        />
                      </td>
                      <td>
                        <select
                          className="form-select employeecreations"
                          value={type}
                          onChange={handleTypeChange}
                          name="role[]"
                        >
                          <option value="">Select Type</option>
                          {fieldTypeArr.map((option) => <>
                                <option key={option.value} value={option.value}>
                                  {option.lable}
                                </option>
                                </>
                            )}
                          {/* <option value="String">String</option>
                          <option value="Dropdown">Dropdown</option>
                          {(props?.selectedModuleOption?.value == "VendorOnboarding") && <option value="MultiField">Multi-Field</option>}
                          <option value="File">File</option> */}
                        </select>
                      </td>
                      <td>
                        <input
                          className="form-control  form_h_modal"
                          value={inputValue}
                          onChange={handleInputValueChange}
                          placeholder="Input Value"
                        />
                        <span style={{ fontSize: '12px', textAlign: 'center', width: '100%', color: '#0505057d' }}>{texted}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="clear_btn_status">
                  <button
                    type="button"
                    className="clear_btn_status_block_list_btnclose"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success save_next_btn"                      
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        {/* Update Row Modal Table  */}
        <Modal
          open={openUpdateFieldModal}
          onClose={handleCloseUpdateFieldModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="lets_block_modal_listing_controlpanel_table"
            sx={style}
          >
            <div className="modal-header">
              <h5 class="modal-title" id="contactModalLabel">
                {confirmObj?.row?.name}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                fdprocessedid="7f6r2r"
                onClick={handleCloseUpdateFieldModal}
              ></button>
            </div>
            <div class="modal-body">
              <div
                className="vendor_configuration_list_block"
               
              >
                <table className="table" id="employeeTable">
                  <thead>
                    <tr>
                      <th className="vendor_tabels_panel">Display Name</th>
                      <th className="vendor_tabels_panel">Type</th>
                      <th className="vendor_tabels_panel">Input Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        
                        <input
                            type="text"
                            className="form-control  form_h_modal"
                            value={confirmObj?.row?.name}
                            onChange={(e) => onUpdateNameInputChange(e)}
                            placeholder="Input Value"
                          />
                       {/* {confirmObj?.row?.name} */}
                      </td>
                      <td>
                        {confirmObj?.row?.type}
                      </td>
                      <td className="d-flex">
                        <div >
                          <input
                            type="text"
                            className="form-control  form_h_modal"
                            value={updateInputText}
                            onChange={(e) => onUpdateInputChange(e)}
                            placeholder="Input Value"
                          />
                          <span style={{ fontSize: '12px', textAlign: 'center', width: '100%', color: '#0505057d' }}>{texted}</span>
                        </div>
                        {(confirmObj?.row?.type == "MultiField" || confirmObj?.row?.type == "File" || confirmObj?.row?.type == "Dropdown") && <div >
                          <Button className="" variant="contained" onClick={onAddInput}>Add</Button>
                        </div>}
                      </td>
                    </tr>
                  </tbody>
                </table>

                {(confirmObj?.row?.type == "MultiField" || confirmObj?.row?.type == "File" || confirmObj?.row?.type == "Dropdown") && <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell className="table_react_listing_controlpanel_block">
                        Sr. No.
                      </StyledTableCell>
                      <StyledTableCell className="table_react_listing_controlpanel_block">
                        Value
                      </StyledTableCell>
                      <StyledTableCell className="table_react_listing_controlpanel_block">
                        Action
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* <StyledTableRow >
                        <StyledTableCell>
                          <label>{1}</label>
                        </StyledTableCell>

                        <StyledTableCell className="cell_tabel_controlpanel_listing_blockss">
                          <label>Yes</label>
                        </StyledTableCell>

                        <StyledTableCell className="cell_tabel_controlpanel_listing_blockss">
                            <DeleteOutlineIcon
                                className="delete_icon_react_block_body"
                                // onClick={() => deleteFile(index, ele?.key, props?.uploadObj?.idx)}
                              />
                        </StyledTableCell>

                      </StyledTableRow> */}
                    {confirmObj?.row?.options?.map((row, index) => (
                      <StyledTableRow key={row.name}>
                        <StyledTableCell>
                          <label>{index + 1}</label>
                        </StyledTableCell>

                        <StyledTableCell className="cell_tabel_controlpanel_listing_blockss">
                          <label>{row?.optionName}</label>
                        </StyledTableCell>

                        <StyledTableCell className="cell_tabel_controlpanel_listing_blockss">
                          <Switch
                            checked={!row.isDeleted}
                            onChange={() => deleteEle(row, index, "required")}
                          />
                            {/* <DeleteOutlineIcon
                                className="delete_icon_react_block_body"
                                onClick={() => deleteEle(row, index)}
                              /> */}
                        </StyledTableCell>

                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>}
                
                <div className="clear_btn_status">
                  <button
                    type="button"
                    className="clear_btn_status_block_list_btnclose"
                    onClick={handleCloseUpdateFieldModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success save_next_btn"
                    onClick={() => handleNewToggle("Modal")}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
        
      </div>
      
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => 99999999 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default ControlPanel1;
